import { AuthUser } from './../@types/auth';

export function haveRight(rights: string[] | undefined, user: AuthUser) {
  if (!rights || user === null) {
    return true;
  }

  return rights.every((right) => {
    return user.rights.indexOf(right) !== -1;
  });
}